import { Filter } from '@empathy/search-types';
import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class ToggleFilterMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.toggleFilter]: (searchState: SearchState,
      { filter, isCompulsory }: { filter: Filter, isCompulsory: boolean }) => {
      if (!(filter.selected && isCompulsory && !filter.parent)) {
        filter.selected = !filter.selected;
        this.toggleFilterHierarchy(filter);
      } else if (filter.selected) {
        this.deselectDescendantFilters(filter);
      }
    },
    [SEARCH_MUTATIONS_KEYS.selectFilter]: (searchState: SearchState, filter: Filter) => {
      filter.selected = true;
      this.toggleFilterHierarchy(filter);
    },
    [SEARCH_MUTATIONS_KEYS.deselectFilter]: (searchState: SearchState, filter: Filter) => {
      filter.selected = false;
      this.toggleFilterHierarchy(filter);
    },
    [SEARCH_MUTATIONS_KEYS.clearFilters]: (searchState: SearchState, selectedFilters: Filter[]) => {
      selectedFilters.forEach(filter => this.deselectFilterAndAncestors(filter));
    }
  };

  private toggleFilterHierarchy(filter: Filter) {
    if (filter.selected) {
      this.selectAncestors(filter);
    } else {
      this.deselectDescendantFilters(filter);
    }
  }

  private deselectDescendantFilters(filter: Filter) {
    filter.children.forEach(child => {
      child.selected = false;
      this.deselectDescendantFilters(child);
    });
  }

  private selectAncestors(filter: Filter) {
    if (filter.parent) {
      filter.parent.selected = true;
      this.selectAncestors(filter.parent);
    }
  }

  private deselectFilterAndAncestors(filter: Filter) {
    filter.selected = false;
    if (filter.parent) {
      this.deselectFilterAndAncestors(filter.parent);
    }
  }
}
